import React from "react";
import style from "./CardContainer.module.scss"

interface Props {
  children: React.ReactNode;
  onClick?: () => void;
}

export function CardContainer({
  children,
  onClick,
}: Props) {
  return <div
    className={`${style.cardContainer} ${onClick ? style.clickable : ""}`}
    onClick={onClick}
  >
    {children}
  </div>
}